import { Flex, Form, InputNumber, Radio as AntdRadio } from "antd"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Card } from "ui/Card"
import { Radio } from "ui/Radio"
import { Text } from "ui/Typography"
import { spacings } from "themes/variables"

export const DURATION_TYPES = {
  SINGLE_DAY: "single_day",
  MULTI_DAY: "multi_day",
}

export const ExperienceDurationType = ({ disabled, form }) => {
  const { t } = useTranslation()
  const durationType = Form.useWatch("duration_type", form)
  const isMultiDay = durationType === DURATION_TYPES.MULTI_DAY

  return (
    <Card title={t("listings.tabs.scheduling.sections.duration_type.title")} className="mb-3xl">
      <Flex vertical gap={spacings.M}>
        <Form.Item name="duration_type" initialValue={DURATION_TYPES.SINGLE_DAY} rules={[{ required: true }]} className="mb-0">
          <AntdRadio.Group disabled={disabled}>
            <Radio value={DURATION_TYPES.SINGLE_DAY}>
              {t("listings.tabs.scheduling.sections.duration_type.single_day")}
            </Radio>
            <Radio value={DURATION_TYPES.MULTI_DAY}>
              {t("listings.tabs.scheduling.sections.duration_type.multi_day")}
            </Radio>
          </AntdRadio.Group>
        </Form.Item>

        {isMultiDay && (
          <Flex align="center" gap={spacings.M}>
            <Text size="m">{t("listings.tabs.scheduling.sections.duration_type.number_of_days")}</Text>
            <Form.Item
              name="number_of_days"
              rules={[{ required: true, message: t("listings.tabs.scheduling.sections.duration_type.number_of_days_required", { defaultValue: "Number of days cannot be blank" }) }, { type: "number", min: 2, message: t("listings.tabs.scheduling.sections.duration_type.min_days_error") }]}
              className="mb-0"
            >
              <InputNumber min={2} disabled={disabled} style={{ width: 174 }} />
            </Form.Item>
          </Flex>
        )}
      </Flex>
    </Card>
  )
}

ExperienceDurationType.propTypes = {
  disabled: PropTypes.bool,
  form: PropTypes.object,
}
